import {flagStyles} from "../../../styles/flag.styles";
import Germany from "./Germany";
import {ReactNode} from "react";

export default interface CountryInfo {
    flag: ReactNode;
    prefix: string;
    flagKey?: keyof typeof flagStyles;
}

export const countries: Record<string, CountryInfo> = {
    "de": {
        flag: <Germany />,
        prefix: "+49",
        flagKey: "germany",
    }
}